// extracted by mini-css-extract-plugin
export default {"title":"HzAr2HHfaHldt8k8eXxm","row":"EUST2TP9de5iQFqnNTtf","cell":"hAyn6IJGKt3VSvjQB9pr","linked":"SVvZ1vkBGM07OfVA9Eqk"};